import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.indicator.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.indicator.fields.name'),
  },
  {
    name: 'periodicity',
    label: i18n('entities.indicator.fields.periodicity'),
  },
  {
    name: 'year',
    label: i18n('entities.indicator.fields.year'),
  },
  {
    name: 'entityType',
    label: i18n('entities.indicator.fields.entityType'),
  },
  {
    name: 'locationEntity',
    label: i18n('entities.indicator.fields.locationEntity'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'assetEntity',
    label: i18n('entities.indicator.fields.assetEntity'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'appUser',
    label: i18n('entities.indicator.fields.appUser'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'formCategoryEntity',
    label: i18n('entities.indicator.fields.formCategoryEntity'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'formTemplateEntity',
    label: i18n('entities.indicator.fields.formTemplateEntity'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'quantity',
    label: i18n('entities.indicator.fields.quantity'),
  },
  {
    name: 'indicator',
    label: i18n('entities.indicator.fields.indicator'),
  },
  {
    name: 'attachments',
    label: i18n('entities.indicator.fields.attachments'),
    render: exporterRenders.filesOrImages(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.indicator.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.indicator.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
